import { render, staticRenderFns } from "./DeleteMonth.vue?vue&type=template&id=5b6b562e&"
import script from "./DeleteMonth.vue?vue&type=script&lang=js&"
export * from "./DeleteMonth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports